<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="breadcrumbs" />
        <h1 class="page-title">Serveurs</h1>
        <p class="page-subtitle">{{ rows.length }} serveur{{ rows.length > 1 ? 's' : '' }}</p>
      </div>
      <v-btn color="primary" depressed @click="openNew">
        <v-icon left small>mdi-plus</v-icon>
        Nouveau serveur
      </v-btn>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <div class="d-flex justify-end mb-3">
        <input v-model="search" type="text" placeholder="Rechercher..." class="search-input" />
      </div>

      <v-card flat class="table-card">
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">NOM</th>
              <th class="text-left">TÉLÉPHONE</th>
              <th class="text-center">STATUT</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in filteredRows" :key="s.id">
              <td class="text-left font-weight-medium">{{ s.name }}</td>
              <td class="text-left text-caption">{{ s.phone || '—' }}</td>
              <td class="text-center">
                <v-chip x-small :color="s.active ? 'success' : 'error'" dark>{{ s.active ? 'Actif' : 'Inactif' }}</v-chip>
              </td>
              <td class="text-right" style="white-space:nowrap;">
                <v-btn icon x-small @click="edit(s)" title="Modifier" class="mr-1">
                  <v-icon small color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon x-small @click="confirmDelete(s)" title="Supprimer">
                  <v-icon small color="error">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="filteredRows.length === 0">
              <td colspan="4" class="text-center text--secondary pa-6">Aucun serveur trouvé</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>

    <!-- Create/Edit dialog -->
    <v-dialog v-model="dialog" max-width="450" @click:outside="close">
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">
          <v-icon color="primary" size="18" class="mr-2">{{ index > -1 ? 'mdi-pencil' : 'mdi-plus-circle' }}</v-icon>
          {{ form_title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-body">
          <div class="form-group">
            <label class="form-label">Nom du serveur *</label>
            <v-text-field v-model="server.name" outlined dense hide-details="auto" placeholder="Ex: Jean, Marie"></v-text-field>
          </div>
          <div class="form-group">
            <label class="form-label">Téléphone</label>
            <v-text-field v-model="server.phone" outlined dense hide-details="auto" placeholder="509..."></v-text-field>
          </div>
          <div class="form-group">
            <label class="form-label">Statut</label>
            <v-switch v-model="server.active" :label="server.active ? 'Actif' : 'Inactif'" dense hide-details></v-switch>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="close">Annuler</v-btn>
          <v-btn color="primary" depressed :loading="loading" @click="save">
            {{ index > -1 ? 'Modifier' : 'Créer' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete confirmation -->
    <v-dialog v-model="deleteDialog" max-width="350">
      <v-card>
        <v-card-title class="text-h6">Supprimer ce serveur ?</v-card-title>
        <v-card-text>Cette action est irréversible.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Annuler</v-btn>
          <v-btn color="error" depressed @click="deleteItem">Supprimer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PreloaderComponent from '../components/PreloaderComponent.vue'
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'

export default {
  name: 'ServersView',
  components: { PreloaderComponent, BreadcrumbComponent },
  data: () => ({
    search: '',
    index: -1,
    loading: false,
    dialog: false,
    deleteDialog: false,
    enable: false,
    rows: [],
    server: { name: '', phone: '', active: true },
    deleteTarget: null,
    form_title: 'Nouveau Serveur',
    store_id: null,
    breadcrumbs: [
      { text: 'Restaurant', disabled: true },
      { text: 'Serveurs', disabled: false },
    ],
  }),
  computed: {
    filteredRows() {
      if (!this.search.trim()) return this.rows
      const q = this.search.toLowerCase()
      return this.rows.filter(r =>
        (r.name || '').toLowerCase().includes(q) ||
        (r.phone || '').toLowerCase().includes(q)
      )
    },
  },
  methods: {
    load() {
      this.$axios.get('/servers?orderasc=name')
        .then(r => { this.rows = r.data; this.enable = true })
        .catch(e => { console.error('Error loading servers:', e); this.enable = true })
    },
    openNew() { this.reset(); this.dialog = true },
    edit(item) {
      this.index = this.rows.indexOf(item)
      this.server = Object.assign({}, item)
      this.form_title = 'Modifier : ' + this.server.name
      this.dialog = true
    },
    save() {
      if (!this.server.name) return
      this.loading = true
      var self = this

      this.server.store_id = this.store_id

      if (this.index > -1) {
        this.$axios.put('/servers/' + this.server.id + '?data=' + encodeURIComponent(JSON.stringify(self.server)))
          .then(function (response) {
            Object.assign(self.rows[self.index], response.data)
            self.dialog = false; self.loading = false
            self.flashMessage.success({ title: 'Succès', message: 'Serveur modifié' })
            self.reset()
          }).catch(function () { self.loading = false })
      } else {
        this.$axios.post('/servers?data=' + encodeURIComponent(JSON.stringify(self.server)))
          .then(function (response) {
            self.rows.push(response.data)
            self.dialog = false; self.loading = false
            self.flashMessage.success({ title: 'Succès', message: 'Serveur créé' })
            self.reset()
          }).catch(function () { self.loading = false })
      }
    },
    confirmDelete(item) {
      this.deleteTarget = item
      this.deleteDialog = true
    },
    deleteItem() {
      if (!this.deleteTarget) return
      var self = this
      this.$axios.delete('/servers/' + this.deleteTarget.id)
        .then(function () {
          self.rows = self.rows.filter(r => r.id !== self.deleteTarget.id)
          self.deleteDialog = false
          self.deleteTarget = null
          self.flashMessage.success({ title: 'Succès', message: 'Serveur supprimé' })
        })
    },
    close() { this.dialog = false; this.reset(); this.loading = false },
    reset() {
      this.server = { name: '', phone: '', active: true }
      this.index = -1
      this.form_title = 'Nouveau Serveur'
    },
    getStore() {
      try {
        var business_id = JSON.parse(localStorage.business).id
        var self = this
        this.$axios.get('/stores?business_id=' + business_id)
          .then(function (response) {
            if (response.data && response.data.length > 0) {
              self.store_id = response.data[0].id
            }
          })
      } catch (e) { console.error(e) }
    },
  },
  mounted() { this.load(); this.getStore() },
}
</script>

<style scoped>
.search-input {
  width: 260px;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 0.85rem;
  transition: border-color 0.15s;
}
.search-input:focus {
  outline: none;
  border-color: var(--v-primary-base, #194173);
}
</style>
